import React, { memo, useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';

import { Box, Button } from '@mui/material';
import { ArrowIcon } from '@sharedCR/coreDesignSystem/icons';
import { LoansPaths } from 'app/configs/routesConfig/loans';
import DisclosureDelivery, { DisclosureDeliveryHost } from 'app/shared/modules/DisclosureDelivery';

import { IconDirection, IconSize } from 'constants/coreDesignSystem';
import { DocumentsSubtabRouteParam, LoanApplicationTabRouteParam } from 'constants/loanApplication';

import { closePrepareDisclosuresWizardAction } from 'store/loanApplications/actions';

import { usePrepareDisclosuresWizard } from '../../hooks';
import { POST_SEND_COPY } from '../../PrepareDisclosuresWizard.constants';
import { PrepareDisclosuresWizardTestIds } from '../../PrepareDisclosuresWizard.testIds';

import { layoutStyles, trackerLinkRowStyles } from './WizardPostSendView.styles';

const WizardPostSendView = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const { applicationId } = usePrepareDisclosuresWizard();

  const handleGoToDisclosures = useCallback(() => {
    dispatch(closePrepareDisclosuresWizardAction());
    history.push(
      LoansPaths.applicationManagement.generatePath({
        applicationId,
        tab: LoanApplicationTabRouteParam.DOCUMENTS,
        subtab: DocumentsSubtabRouteParam.DISCLOSURES,
      }),
    );
  }, [dispatch, history, applicationId]);

  return (
    <Box data-testid={PrepareDisclosuresWizardTestIds.POST_SEND} sx={layoutStyles}>
      <DisclosureDelivery host={DisclosureDeliveryHost.WIZARD_POST_SEND} />
      <Box sx={trackerLinkRowStyles}>
        <Button
          color="primary"
          data-testid={PrepareDisclosuresWizardTestIds.POST_SEND_TRACKER_LINK}
          endIcon={<ArrowIcon direction={IconDirection.RIGHT} size={IconSize[16]} />}
          variant="text"
          onClick={handleGoToDisclosures}
        >
          {POST_SEND_COPY.goToDisclosures}
        </Button>
      </Box>
    </Box>
  );
};

export default memo(WizardPostSendView);
